import React from 'react';
import Button from '../ui/Button';

const ContextualActionController = ({ 
  currentScreen = 'landing',
  isValid = true,
  isLoading = false,
  onAction,
  secondaryText = null,
  showBackButton = false,
  onBack
}) => {
  const getActionConfig = () => {
    switch (currentScreen) {
      case 'landing':
        return {
          label: 'Start Assessment',
          icon: 'ArrowRight',
          variant: 'default',
          loadingText: 'Loading...'
        };
      case 'question-assessment':
        return {
          label: 'Continue',
          icon: 'ArrowRight',
          variant: 'default',
          loadingText: 'Saving...'
        };
      case 'email-capture':
        return {
          label: 'Get Results',
          icon: 'Mail',
          variant: 'default',
          loadingText: 'Processing...'
        };
      case 'personalized-results':
        return {
          label: 'Download Results',
          icon: 'Download',
          variant: 'outline',
          loadingText: 'Preparing...'
        };
      default:
        return {
          label: 'Continue',
          icon: 'ArrowRight',
          variant: 'default',
          loadingText: 'Loading...'
        };
    }
  };

  const actionConfig = getActionConfig();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-brand-charcoal/95 backdrop-blur-sm border-t border-brand-slate">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 py-3 md:py-4">
        <div className="flex gap-3">
          {showBackButton && (
            <Button
              variant="outline"
              size="lg"
              iconName="ArrowLeft"
              iconPosition="left"
              onClick={onBack}
              disabled={isLoading}
              className="w-auto"
            >
              Back
            </Button>
          )}
          
          <Button
            variant={actionConfig?.variant}
            size="lg"
            iconName={actionConfig?.icon}
            iconPosition="right"
            onClick={onAction}
            disabled={!isValid || isLoading}
            loading={isLoading}
            fullWidth={!showBackButton}
            className={showBackButton ? 'flex-1' : ''}
          >
            {isLoading ? actionConfig?.loadingText : actionConfig?.label}
          </Button>
        </div>

        {secondaryText && (
          <div className="mt-3 text-center text-sm text-brand-steel">
            {secondaryText}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContextualActionController;